import { render } from "./SellOrderByProductList.vue?vue&type=template&id=647868b2"
import script from "./SellOrderByProductList.vue?vue&type=script&lang=js"
export * from "./SellOrderByProductList.vue?vue&type=script&lang=js"

import "./SellOrderByProductList.vue?vue&type=style&index=0&id=647868b2&lang=css"
script.render = render

export default script